export default __webpack_public_path__ + "static/media/buyInsurancePolicyLogo.27d82888.svg";